import { ProvinceDetailPage } from "@/features/geolocation/page/ProvinceDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/geolocation/province/$id/detail")({
  component: ProvinceDetailPage,
});
